import React from "react";
import { useHistory } from "react-router-dom";

import {
  Context,
  FETCH_TEACHING_MATERIALS_SUCCESS,
  FETCH_TEACHING_MATERIALS_FAILURE,
  fetchTeachingMaterials,
  teachingMaterialPath,
} from "../../../studentStore";
import { FETCH_FAILURE_MESSAGE } from "../../../studentStore/messages";
import useRequestStatus from "../../../hooks/useRequestStatus";
import Toast from "../../../molecules/Toast";
import Loading from "../../../molecules/Loading";
import MaterialList from "../../../templates/student/MaterialsList";

export default () => {
  const { state, dispatch } = React.useContext(Context);
  const history = useHistory();
  const [showMsg, setShowMsg] = React.useState<{
    text: string;
    type: string;
  }>({
    text: "",
    type: "",
  });
  const fetchTeachingMaterialsRequestStatus = useRequestStatus({
    lastAction: state.lastAction,
    successAction: FETCH_TEACHING_MATERIALS_SUCCESS,
    failureAction: FETCH_TEACHING_MATERIALS_FAILURE,
  });

  React.useEffect(() => {
    dispatch(fetchTeachingMaterials());
  }, [dispatch]);

  React.useEffect(() => {
    if (fetchTeachingMaterialsRequestStatus === "error") {
      setShowMsg({
        text: FETCH_FAILURE_MESSAGE,
        type: "error",
      });
    }
  }, [fetchTeachingMaterialsRequestStatus]);

  const directTo = React.useCallback(
    (teaching_material_id: number, lesson_id: number, round_no: number) => {
      const roundNoParam = round_no > 1 ? `&round=${round_no}` : "";
      history.push(
        `${teachingMaterialPath}/${teaching_material_id}?lesson=${lesson_id}${roundNoParam}`,
      );
    },
    [history],
  );

  if (fetchTeachingMaterialsRequestStatus === "loading") {
    return <Loading />;
  }

  return (
    <>
      {showMsg.text && (
        <Toast
          onClose={() =>
            setShowMsg({
              text: "",
              type: "",
            })
          }
          message={showMsg}
        />
      )}
      {fetchTeachingMaterialsRequestStatus === "success" && (
        <MaterialList
          teaching_materials={state.teaching_materials}
          directTo={directTo}
        />
      )}
    </>
  );
};
